import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import StudentTasks from "./StudentTasks";


function StudentTaskMain() {

    let { path } = useRouteMatch();
    return (
        <main className="flex h-screen bg-white">
                <div className="h-screen px-4 py-6 sm:px-2 max-w-screen max-h-screen my-auto mx-auto lg:px-8 flex flex-grow flex-col bg-white ">
                    <Switch>
                        <Route exact path={path}>
                            <h1 className="text-3xl font-bold leading-tight text-gray-900">Oppilaan UI</h1>
                            <Link to={`${path}/tasks`}>
                                <button
                                    type="button"
                                    className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    Tehtävät
                                </button>
                            </Link>
                        </Route>
                        <Route path={`${path}/tasks`}>
                            <StudentTasks />
                        </Route>
                    </Switch>
                </div>
            </main>
       
    );
}


export default StudentTaskMain;
